function convertUrlsToUploadFiles(urls) {
  return urls.map((url, index) => ({
    uid: `-${index}`,
    name: `image-${index}.jpg`,
    status: 'done',
    url: url,
  }))
}

export default convertUrlsToUploadFiles;